/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import MsDyn365, { IImageSettings, Image, RichTextComponent } from '@msdyn365-commerce/core';
import * as React from 'react';
import { IMfrmProductDescriptionViewProps } from './mfrm-product-description';

// tslint:disable-next-line: cyclomatic-complexity
export default (props: IMfrmProductDescriptionViewProps) => {
    const imageURL = props.context.request.apiSettings.baseImageUrl;
    const slashExist = imageURL.endsWith('/');
    const ImageBaseUrl = slashExist ? imageURL.slice(0, -1) : imageURL;
    const spotlightIconSettings: IImageSettings = {
        viewports: {
            xs: { q: `w=48&h=48&m=1`, w: 48, h: 48 },
            lg: { q: `w=48&h=48&m=1`, w: 48, h: 48 },
            xl: { q: `w=48&h=48&m=1`, w: 48, h: 48 }
        },
        lazyload: false
    };
    return (
        <div className={props.noContent ? 'mfrm-tab-accordion__no-content' : 'mfrm-tab-accordion__description-tab'}>
            {props.spotlightTitle && props.spotlightTitle.length > 0 && (
                <div className='mfrm-spotlight__container'>
                    <h4 className='mfrm-spotlight__title'>{props.config.heading && props.config.heading.text}</h4>
                    <ul className='mfrm-spotlight__items'>
                        {props.spotlightTitle.map(i => {
                            const fallbackImageUrl = `${ImageBaseUrl}default_spotlight.png`;
                            return (
                                <li className={i.icon} key={i.label}>
                                    {i.icon && (
                                        <Image
                                            gridSettings={props.context.request.gridSettings!}
                                            imageSettings={spotlightIconSettings}
                                            src={`${ImageBaseUrl + i.icon}.png`}
                                            altText={i.label}
                                            loadFailureBehavior='empty'
                                            fallBackSrc={fallbackImageUrl}
                                            className={'mfrm-spotlight__icon'}
                                        />
                                    )}
                                    {i.label}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
            {props.noContent ? (
                props.resources.noDataText
            ) : (
                    <div className={props.mediaContent ? 'mfrm-tab-accordion__enhanced-content' : 'mfrm-tab-accordion__content'}>
                        {props.mediaContent && props.forceDisplay ? (
                            <div className='mfrm-tab-accordion__media'>{props.mediaContent}</div>
                        ) : (
                                <RichTextComponent text={props.mediaContent} className='mfrm-tab-accordion__media' />
                            )}

                        {props.customText && (
                            <div className='mfrm-tab-accordion__text'>
                                {MsDyn365.isBrowser && props.state.isMobileTablet &&
                                    <RichTextComponent text={props.state.isOpen ? `${props.customText} ` : props.customText.length > 350 ? `${props.customText.slice(0, 350)}... ` : props.customText} />
                                }
                                {MsDyn365.isBrowser && props.state.isMobileTablet && props.customText && props.customText.length > 350 ?
                                    <a className='mfrm-tab-accordion__more-cta' onClick={props.toggle} role='button' href='javascript:void(0)'>
                                        {props.state.isOpen ? props.resources.seeLessText : props.resources.seeMoreText}
                                    </a> : <></>
                                }
                                {(!MsDyn365.isBrowser || props.state.isDesktop) &&
                                    <RichTextComponent text={props.customText} />
                                }
                            </div>
                        )}
                    </div>
                )}
        </div>
    );
};
